import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getPathWithParams } from '../../../helpers/router';
import { businessRoutes } from '../../../utils/routes';
import HashLink from '../helpers/Link';

class MenuList extends Component {
	render() {
		const { t, handleMenuToggle, language } = this.props;
	
		return (
			<div className="landing-header-menu">
				<div className="landing-header-nav">
					{t("landing.header.menu", { returnObjects: true }).map(
						({ text, href }, index) => (
							<HashLink
								key={index}
								type="internal"
								href={href}
								handleMenuToggle={handleMenuToggle}
							>
								{text}
							</HashLink>
						)
					)}
				</div>
				<div className="landing-header-buttons">
					<Link
						to={getPathWithParams({
							path: businessRoutes.login,
							params: { language },
							app: 'business',
						})}
						className="landing-button-white"
					>
						{t("landing.header.button_log.text")}
					</Link>
					<Link
						to={getPathWithParams({
							path: businessRoutes.register,
							params: { language },
							app: 'business',
						})}
						className="landing-button-blue"
					>
						{t("landing.header.button_reg.text")}
					</Link>
				</div>
			</div>
		);
	}
}

export default MenuList;
